import { render, staticRenderFns } from "./ConfirmaCodigo.vue?vue&type=template&id=4a881ae6&scoped=true"
import script from "./ConfirmaCodigo.vue?vue&type=script&lang=ts"
export * from "./ConfirmaCodigo.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmaCodigo.vue?vue&type=style&index=0&id=4a881ae6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a881ae6",
  null
  
)

export default component.exports